import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { AuthService } from '../../../service/auth.service';
import { UsuarioService } from '../../../service/usuario.service';
import { Usuario } from '../../../model/usuario/usuario.model';
import { IconeModuloUtils } from '../../../util/icone-modulo.utils';

@Component({
  selector: 'app-menu-mobile',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './menu-mobile.component.html',
  styleUrl: './menu-mobile.component.css'
})
export class MenuMobileComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<MenuMobileComponent>>(MatDialogRef);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly domSanitizer = inject(DomSanitizer);

  usuario: Usuario = this.authService.getUsuarioLogado();
  modulos: any[] = [];
  moduloSelecionado: any = null;
  rotinaSelecionada: any = null;
  moduloExpandidoId: number | null = null;

  ngOnInit() {
    this.modulos = this.authService.getModulos ?? [];

    for (const modulo of this.modulos) {
      for (const rotina of modulo.rotinas ?? []) {
        if (window.location.pathname.includes(rotina.url)) {
          this.moduloSelecionado = modulo;
          this.rotinaSelecionada = rotina;
          this.moduloExpandidoId = modulo.idModulo;
          break;
        }
      }
    }

    this.usuarioService.buscarUsuarioLogado().subscribe({
      next: usuario => this.usuario = usuario
    });
  }

  iconeModulo(iconeModulo: string, selecionado: boolean): string {
    return IconeModuloUtils.caminho(iconeModulo, selecionado ? '-roxo' : '');
  }

  get urlFotoUsuario(): SafeUrl | null {
    if (!this.usuario.extensaoImg || !this.usuario.uuid) {
      return null;
    }
    const grupo = this.authService.getUsuarioLogado().grupo;
    return this.domSanitizer.bypassSecurityTrustUrl(
      `${environment.urlRepositorioClaribot}/${grupo}/usuario-img/${this.usuario.uuid}.${this.usuario.extensaoImg}`
    );
  }

  irParaHome() {
    this.moduloSelecionado = null;
    this.rotinaSelecionada = null;
    this.router.navigate(['/index']);
    this.fechar();
  }

  clicarModulo(modulo: any) {
    if (modulo.rotinas?.length === 1) {
      this.moduloSelecionado = modulo;
      this.rotinaSelecionada = modulo.rotinas[0];
      this.router.navigate([modulo.rotinas[0].url]);
      this.fechar();
      return;
    }

    this.moduloSelecionado = modulo;
    this.moduloExpandidoId = this.moduloExpandidoId === modulo.idModulo ? null : modulo.idModulo;
  }

  clicarRotina(modulo: any, rotina: any) {
    this.moduloSelecionado = modulo;
    this.rotinaSelecionada = rotina;
    this.router.navigate([rotina.url]);
    this.fechar();
  }

  sair() {
    this.authService.logout();
    this.fechar();
  }

  fechar() {
    this.dialogRef.close();
  }
}
